import faqReducer, { EVENT_REDUCER_KEY } from './eventReducer';

export { EVENT_REDUCER_KEY };

export default faqReducer;
